import {getPrefixedLogger} from '@netx/core-next/instance/logger';
import {AttributeTemplateType, type IAttributeTemplate} from '../schema';

export * from './date';
export * from './number';
export * from './select';
export * from './semantic';
export * from './tag';
export * from './text';
export * from './textarea';

import date from './date';
import number from './number';
import select from './select';
import semantic from './semantic';
import tag from './tag';
import text from './text';
import textarea from './textarea';

const logger = getPrefixedLogger('attribute-parser');

export const parsers = {
	[AttributeTemplateType.DATE]: date,
	[AttributeTemplateType.NUMBER]: number,
	[AttributeTemplateType.SELECT]: select,
	[AttributeTemplateType.SEMANTIC]: semantic,
	[AttributeTemplateType.HIERARCHICAL]: (value: any) => value,
	[AttributeTemplateType.TAG]: tag,
	[AttributeTemplateType.TEXT]: text,
	[AttributeTemplateType.TEXTAREA]: textarea,
} as const;

export const getAttributeParser = (
	type: AttributeTemplateType,
): typeof parsers[keyof typeof parsers] | undefined =>
	parsers[type as keyof typeof parsers];

export const parseAttributeValue = <T extends IAttributeTemplate>(
	attribute: T,
	value: Parameters<typeof parsers[T['type']]>[0],
) => {
	try {
		const parser = getAttributeParser(attribute.type);
		if (!parser) throw new Error(`No parser found`);
		return parser(value);
	} catch (ex: any) {
		logger.warn(
			`Error parsing value for attribute type ${attribute.type} with name ${attribute.name} and value ${value}`,
			ex.message,
		);
		return value;
	}
};

export default parsers;
